export const LOBBY_SCREEN = 0;
export const WATCH_SCREEN = 1;
export const CREATE_SCREEN = 2;
export const PLAY_SCREEN = 3;
export const GRIDVIEW_SCREEN = 4;
export const PORTFOLIO_SCREEN = 5